import React, { useMemo } from "react";

import {
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  LabelList,
  ReferenceLine
} from "recharts";

/*
Older Tooltip Logic Not being used
const CustomTooltipWaterfall = ({ active, payload, label }) => {
  if (active && payload && payload.length > 0) {
    const data = payload[0].payload;
    const fillColor = data.fill || "#a4b0be";
    const displayValue = payload?.close - payload?.open
    return (
      <div
        style={{
          backgroundColor: "#fff",
          border: '1px solid #ccc',
          // border: `1px solid ${fillColor}`,
          padding: "8px",
          borderRadius: "4px",
          color: fillColor,
          fontSize: "14px",
        }}
      >
        <p>{label}</p>
        <p style={{ color: fillColor }}>
          {!isNaN(data.value) ? data.value : "N/A"}
        </p>
      </div>
    );
  }

  return null;
};
*/

// const CustomTooltip = ({ active, payload, label }) => {
//   console.log("payloadTooltip", payload)
//   if (active && payload && payload.length) {
//     return (
//       <div style={{ backgroundColor: "#fff", padding: "10px", border: "1px solid #ccc" }}>
//         <div style={{ display: 'flex', alignItems: 'center' }}>
//           <strong>{label}</strong>
//           {payload.map((entry, index) => (
//             <p key={index} style={{ color: '#000', margin: '0 5px' }}>
//               {/* Label and value in the same line */}
//               {entry.value}
//             </p>
//           ))}
//         </div>
//       </div>
//     );
//   }
//   return null;
// };

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div
        style={{
          backgroundColor: "#fff",
          padding: "10px",
          border: "1px solid #ccc"
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <strong>{label}</strong>
          {payload.map((entry, index) => {
            if (index === 1) {
              return (
                <p key={index} style={{ color: "#000", margin: "0 5px" }}>
                  {entry.value}
                </p>
              );
            }
            return null;
          })}
        </div>
      </div>
    );
  }
  return null;
};

function SCMWaterfallChart({ waterfallChartData, toggleValue }) {
  const data = useMemo(() => {
    if (!toggleValue) {
      return waterfallChartData?.valueData || [];
    } else {
      return waterfallChartData?.percentData || [];
    }
  }, [toggleValue, waterfallChartData]);

  // Custom shape to prevent hover effects
  const NoHoverShape = ({ x, y, width, height, fill }) => (
    <rect x={x} y={y} width={width} height={height} fill={fill} />
  );

  // Active shape override to disable hover rendering
  const EmptyShape = () => null;

  // const uvValues = data?.map(d => d.uv);
  // const minY = Math.min(...uvValues);
  // const maxY = Math.max(...uvValues);

  // // Estimate tick interval (based on Recharts default: ~5 ticks)
  // const interval = (maxY - minY) / 5;

  // // Generate ticks with extra top & bottom, rounded to 2 decimals
  // const ticks = [];
  // const start = minY - interval;
  // const end = maxY + interval;

  // for (let i = start; i <= end + 0.0001; i += interval) {
  //   ticks.push(Number(i.toFixed(2)));
  // }

  return (
    <>
      <style>
        {`
    .recharts-active-bar {
      fill-opacity: 1 !important;
    }
  `}
      </style>

      <BarChart
        width={650}
        height={345}
        data={data}
        margin={{ top: 20, right: 30, left: -10, bottom: 25 }}
      >
        <CartesianGrid horizontal={true} vertical={false} stroke="#DFDFDF" />

        <XAxis
          dataKey="name"
          tickLine={false}
          axisLine={false}
          interval={0}
          scaleToFit
          allowDataOverflow={true}
          width={100}
          tick={{
            fontSize: 12,
            wordBreak: "break-word",
            width: 50
          }}
          tickFormatter={value =>
            value == null || String(value).trim() === "" ? "NULL" : value
          }
        />

        <YAxis
          tickLine={false}
          axisLine={false}
          //   tickFormatter={(val) => val.toFixed(2)}
          //   domain={() => {
          //     const values = data.map(d => d.uv);
          //     const maxAbs = Math.ceil(Math.max(...values.map(Math.abs)) * 0.1); // optional padding
          //     return [-maxAbs, maxAbs];
          //   }}
          //   ticks={(() => {
          //     const maxAbs = Math.ceil(Math.max(...data.map(d => Math.abs(d.uv))) * 0.1);
          //     const step = maxAbs / 2;
          //     return [-maxAbs, -step, 0, step, maxAbs];
          //   })()}
        />

        {/* <ReferenceLine y={0} stroke="#000" strokeWidth={1.5} /> */}

        <Tooltip content={<CustomTooltip />} cursor={{ fill: "transparent" }} />

        <Bar
          dataKey="pv"
          stackId="a"
          fill="transparent"
          // shape={<NoHoverShape />}
          activeShape={<EmptyShape />}
          isAnimationActive={false}
        />

        <Bar
          dataKey="uv"
          stackId="a"
          fill="#82ca9d"
          // shape={<NoHoverShape />}
          activeShape={<EmptyShape />}
          isAnimationActive={false}
        >
          {data?.map((item, index) => {
            const purchaseCost = data.find(d => d.name === "Purchase Cost")?.uv;
            const shouldCost = data.find(d => d.name === "Should Cost")?.uv;

            if (
              [
                "Material Cost",
                "Indirect Cost",
                "Logistics Cost",
                // "Overhead Cost",
                "Overhead and Indirects Cost",
                "Conversion Cost",
                "Value Add Cost",
                "Profit"
              ].includes(item.name)
            ) {
              return <Cell key={index} fill="#33ABDA" fillOpacity={1} />;
            }

            if (item.name === "Should Cost") {
              return <Cell key={index} fill="#0078A7" fillOpacity={1} />;
            }

            if (item.name === "Gap") {
              if (purchaseCost < shouldCost) {
                return <Cell key={index} fill="#CCE7DD" fillOpacity={1} />;
              } else if (purchaseCost > shouldCost) {
                return <Cell key={index} fill="#F6CCD2" fillOpacity={1} />;
              }
            }

            if (item.name === "Purchase Cost") {
              if (purchaseCost < shouldCost) {
                return <Cell key={index} fill="#006A42" fillOpacity={1} />;
              } else if (purchaseCost > shouldCost) {
                return <Cell key={index} fill="#AA001A" fillOpacity={1} />;
              }
            }

            return <Cell key={index} fill="#228B22" fillOpacity={1} />;
          })}
          {/* Old logic */}
          {/* <LabelList
  dataKey="uv"
  content={({ x, y, value, width, index }) => {
    const isNegative = value < 0;
    const labelY = isNegative ? y + 15 : y - 10;

    const itemName = data?.[index]?.name;
    const shouldAddPercent = itemName !== "Should Cost" && itemName !== "Purchase Cost";

    return (
      <text
        x={x + width / 2}
        y={labelY}
        fill="#616161"
        textAnchor="middle"
        fontSize={14}
        fontWeight={500}
      >
        {!toggleValue
          ? value.toFixed(2)
          : shouldAddPercent
            ? `${value.toFixed(2)} %`
            : value.toFixed(2)}
      </text>
    );
  }}
/> */}

          {/* <LabelList
  dataKey="uv"
  content={({ x, y, value, width, height, index }) => {
    const itemName = data?.[index]?.name;
    const shouldAddPercent = itemName !== "Should Cost" && itemName !== "Purchase Cost";

    // Always place label slightly above the top of the bar
    const barTopY = value < 0 ? y + height : y;
    const labelY = barTopY - 8; // adjust padding as needed

    return (
      <text
        x={x + width / 2}
        y={labelY}
        fill="#616161"
        textAnchor="middle"
        fontSize={14}
        fontWeight={500}
      >
        {!toggleValue
          ? value.toFixed(2)
          : shouldAddPercent
            ? `${value.toFixed(2)} %`
            : value.toFixed(2)}
      </text>
    );
  }}
/> */}

          {/* 100% logic */}
          <LabelList
            dataKey="uv"
            content={({ x, y, value, width, height, index }) => {
              const itemName = data?.[index]?.name;
              const barTopY = value < 0 ? y + height : y;
              const labelY = barTopY - 8;

              // Extract the "Gap" value from the data
              const gapItem = data?.find(item => item.name === "Gap");
              const gapValue = gapItem?.uv || 0;

              let labelText = value.toFixed(2);

              if (toggleValue) {
                if (itemName === "Should Cost") {
                  labelText = `${value}%(${waterfallChartData?.valueData.find(item => item.name === "Should Cost")?.uv?.toFixed(2)})`;
                } else if (itemName === "Purchase Cost") {
                  const totalPercent = 100 + gapValue;
                  labelText = `${totalPercent.toFixed(2)}%(${waterfallChartData?.valueData.find(item => item.name === "Purchase Cost")?.uv?.toFixed(2)})`;
                } else {
                  labelText = `${labelText}%`;
                }
              }

              return (
                <text
                  x={x + width / 2}
                  y={labelY}
                  fill="#616161"
                  textAnchor="middle"
                  fontSize={12}
                  fontWeight={500}
                >
                  {labelText}
                </text>
              );
            }}
          />
        </Bar>
      </BarChart>
    </>
  );
}

export default SCMWaterfallChart;
